module.exports = __webpack_public_path__ + "img/UBET.1b2f94e2.svg";